import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, message, Dropdown } from 'antd';
import {
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  MenuOutlined,
  HomeOutlined,
  BellOutlined
} from '@ant-design/icons';
import axios from 'axios';
import Login from './components/Login';
import Workers from './components/Workers';
import Users from './components/Users';
import Settings from './components/Settings';
import './App.css';

const { Header, Content } = Layout;

const API_URL = '/api/auth';

function App() {
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('workers');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      try {
        await axios.post(`${API_URL}/verify`, { token });
        setUser(JSON.parse(savedUser));
      } catch (error) {
        handleLogout();
      }
    }
    setChecking(false);
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setCurrentPage('workers');
  };

  const menuItems = [
    {
      key: 'workers',
      icon: <TeamOutlined />,
      label: 'Сотрудники',
      onClick: () => setCurrentPage('workers')
    },
    ...(user?.role === 'admin' ? [{
      key: 'users',
      icon: <SettingOutlined />,
      label: 'Пользователи',
      onClick: () => setCurrentPage('users')
    }] : []),
    {
      key: 'settings',
      icon: <BellOutlined />,
      label: 'Настройки',
      onClick: () => setCurrentPage('settings')
    }
  ];

  // Mobile menu items for dropdown
  const mobileMenuItems = [
    {
      key: 'workers',
      icon: <TeamOutlined />,
      label: 'Сотрудники',
      onClick: () => setCurrentPage('workers')
    },
    ...(user?.role === 'admin' ? [{
      key: 'users',
      icon: <SettingOutlined />,
      label: 'Пользователи',
      onClick: () => setCurrentPage('users')
    }] : []),
    {
      key: 'settings',
      icon: <BellOutlined />,
      label: 'Настройки',
      onClick: () => setCurrentPage('settings')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Выход',
      onClick: handleLogout,
      danger: true
    }
  ];

  const renderContent = () => {
    switch (currentPage) {
      case 'users':
        return <Users />;
      case 'settings':
        return <Settings />;
      case 'workers':
      default:
        return <Workers />;
    }
  };

  if (checking) {
    return <div className="loading-screen">Загрузка...</div>;
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header className="app-header">
        <div className="header-content">
          <div className="header-title">
            Учет мигрантов
          </div>
          {/* Desktop menu */}
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[currentPage]}
            items={menuItems}
            className="header-menu desktop-only"
            style={{ background: 'transparent' }}
          />
        </div>
        {/* Mobile dropdown menu - вынесено за пределы header-content */}
        <div className="mobile-only">
          <Dropdown
            menu={{ items: mobileMenuItems }}
            placement="bottomRight"
            trigger={['click']}
            classNames={{ root: 'mobile-dropdown-menu' }}
          >
            <Button
              type="primary"
              ghost
              icon={<MenuOutlined />}
              className="mobile-menu-btn"
            />
          </Dropdown>
        </div>
        {/* Desktop user section */}
        <div className="header-right desktop-only">
          <span className="header-username">{user.username}</span>
          <Button 
            type="primary" 
            ghost 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
            className="header-logout-btn"
          >
            Выход
          </Button>
        </div>
      </Header>
      <Content style={{ background: '#f0f2f5' }}>
        {renderContent()}
      </Content>
    </Layout>
  );
}

export default App;
